import { Injectable } from "@angular/core";
import { IID_OL_ACTIVATION_REQUEST } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolActivationRequestStore } from "./iidOlActivationRequest.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ACTIVATION_REQUEST)
export class IIDolActivationRequestQuery extends AbstractInterfaceDataQuery<IID_OL_ACTIVATION_REQUEST> {
  constructor(protected store: IIDolActivationRequestStore) {
    super(store);
  }
}
